import { render, staticRenderFns } from "./taiwan3D.vue?vue&type=template&id=dbd246ea&"
import script from "./taiwan3D.vue?vue&type=script&lang=js&"
export * from "./taiwan3D.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports